import styled from 'styled-components';

import { Body } from '@cognite/cogs-core-v11/tokens/typography/typography.tsx';
import { Button } from '@cognite/cogs-core-v11/components/button/button.tsx';

export const ConfirmationBody = styled(Body)`
  margin-bottom: 16px;
`;

export const ExtraContent = styled.div`
  margin-bottom: 16px;
`;

export const SaveButton = styled(Button)`
  width: 200px;
`;
